import api from "@/core/services/api.service";

const payrollService = {
    
    searchPerson(params) {
        api.setHeader()
        return api.post("api/payroll/search", params)
    },

    save(params) {
        api.setHeader()
        return api.post("api/payroll/save", params)
    },
    update(params) {
        api.setHeader()
        return api.post("api/payroll/update", params)
    },

    getData(params) {
        api.setHeader()
        return api.post("api/payroll/list", params)
    },

    editItem(params) {
        api.setHeader()
        return api.post("api/payroll/edit", params)
    },

    deleteItem(params) {
        api.setHeader()
        return api.post("api/payroll/delete", params)
    },

    getPoomDanes() {
        api.setHeader()
        return api.post("api/payroll/poomdan")
    }

}

export default payrollService